var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-icon',{staticClass:"closePageButton",attrs:{"name":"cross"},on:{"click":function($event){return _vm.$router.back()}}})}
var staticRenderFns = []

export { render, staticRenderFns }